export default __webpack_public_path__ + "static/media/Punto_12_Cantina_Palio_Marinaro_DEU_Def.4b9b1144.aac";